import React from 'react';

const jobTitleOptions = [
  'Actor',
  'Actress',
  'Singer',
  'Dancer',
  'Director',
  'Casting Director',
  'Choreographer',
  'Music Director',
  'Stage Manager',
  'Producer',
  'Playwright',
  'Composer',
  'Lyricist',
  'Scenic Designer',
  'Costume Designer',
  'Lighting Designer',
  'Sound Designer',
  'Agent',
  'Manager',
  'Voice Actor',
  'Stunt Performer',
  'Other',
];

function HomeTab({
  performerProfile,
  setPerformerProfile,
  profileSettings,
  setProfileSettings,
  professions,
  newProfession,
  setNewProfession,
  handleAddProfession,
  handleDeleteProfession,
  renderPhotoSlot,
  handleSaveAll,
  saving,
}) {
  return (
    <>
      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Basic Info</h2>
          <p>Your name and what appears below it on your landing page</p>
        </div>
        <div className="form-group">
          <label>Display Name</label>
          <input
            type="text"
            value={performerProfile.display_name || ''}
            onChange={(e) =>
              setPerformerProfile({ ...performerProfile, display_name: e.target.value })
            }
            placeholder="Your professional name"
          />
        </div>

        <div className="hero-subtitle-picker">
          <label>Subtitle Style</label>
          <p className="hero-subtitle-hint">
            Choose what appears under your name on the landing page.
          </p>
          <div className="hero-subtitle-options">
            <button
              className={`hero-subtitle-option${(profileSettings.hero_subtitle || 'tagline') === 'tagline' ? ' active' : ''}`}
              onClick={() => setProfileSettings({ ...profileSettings, hero_subtitle: 'tagline' })}
            >
              Tagline
            </button>
            <button
              className={`hero-subtitle-option${profileSettings.hero_subtitle === 'professions' ? ' active' : ''}`}
              onClick={() =>
                setProfileSettings({ ...profileSettings, hero_subtitle: 'professions' })
              }
            >
              Profession List
            </button>
            <button
              className={`hero-subtitle-option${profileSettings.hero_subtitle === 'none' ? ' active' : ''}`}
              onClick={() => setProfileSettings({ ...profileSettings, hero_subtitle: 'none' })}
            >
              None
            </button>
          </div>
        </div>

        {(profileSettings.hero_subtitle || 'tagline') === 'tagline' && (
          <div className="form-group">
            <label>Tagline</label>
            <input
              type="text"
              value={performerProfile.tagline || ''}
              onChange={(e) =>
                setPerformerProfile({ ...performerProfile, tagline: e.target.value })
              }
              placeholder="Actress, producer, and advocate with a knack for storytelling."
            />
            <small>Your elevator pitch. Displayed on the hero of most templates.</small>
          </div>
        )}

        {profileSettings.hero_subtitle === 'professions' && (
          <>
            <div className="professions-list">
              {professions.length > 0 ? (
                professions.map((prof) => (
                  <span key={prof.id} className="profession-tag">
                    {prof.profession}
                    <button
                      className="btn-remove-tag"
                      onClick={() => handleDeleteProfession(prof.id)}
                    >
                      ×
                    </button>
                  </span>
                ))
              ) : (
                <span className="empty-professions">No professions added yet</span>
              )}
            </div>
            <div className="add-profession-row">
              <select value={newProfession} onChange={(e) => setNewProfession(e.target.value)}>
                <option value="">Select a profession...</option>
                {jobTitleOptions.map((title) => (
                  <option key={title} value={title}>
                    {title}
                  </option>
                ))}
              </select>
              <button className="btn-add-small" onClick={handleAddProfession}>
                + Add
              </button>
            </div>
          </>
        )}
      </div>

      {renderPhotoSlot(
        'headshot',
        'Hero Photos',
        'Choose photos from your library for the hero section. Up to 4 arranged in a grid.'
      )}

      <button className="btn-save-section" onClick={handleSaveAll} disabled={saving}>
        {saving ? 'Saving...' : 'Save Home'}
      </button>
    </>
  );
}

export default HomeTab;
